import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { parse } from 'hub-http/helpers/params';
import ViewContainerContext from '../containers/ViewContainerContext';
import PresentationRecord from '../records/PresentationRecord';
import LegalConsentRecord from '../records/LegalConsentRecord';
import * as MeetingsLinkActions from '../actions/MeetingsLinkActions';
import PublicViewLoading from '../components/view/PublicViewLoading';
import { ThemeProvider } from 'foundations-theming/components/ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export default ((ChildComponent, {
  isPreview = false,
  documentActions,
  hasHigherDocumentsLimit,
  publicViewerActions
}) => {
  class DecoratedViewContainer extends Component {
    constructor(props) {
      super(props);
      this.state = {
        childContext: {
          isPreview,
          hasHigherDocumentsLimit
        }
      };
    }
    componentDidMount() {
      const {
        match,
        presentation,
        legalConsent,
        fetchPresentation,
        fetchLegalConsent,
        legalConsentLangLoading
      } = this.props;
      const {
        presentationId
      } = match.params;
      const locationQuery = parse(window.location.search.replace('?', ''));
      const {
        accessId
      } = locationQuery;
      if (!presentation) {
        fetchPresentation(presentationId, accessId);
      }
      if (!isPreview && !legalConsent && !legalConsentLangLoading) {
        fetchLegalConsent(presentationId, accessId);
      }
    }
    render() {
      const isLegalConsentLoading = !isPreview && !this.props.legalConsent && !this.props.legalConsentFailed;
      if (this.props.presentation === null || isLegalConsentLoading) {
        return /*#__PURE__*/_jsx(ThemeProvider, {
          children: /*#__PURE__*/_jsx(PublicViewLoading, {})
        });
      }
      return /*#__PURE__*/_jsx(ViewContainerContext.Provider, {
        value: this.state.childContext,
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          children: /*#__PURE__*/_jsx(ChildComponent, Object.assign({}, this.props))
        })
      });
    }
  }
  DecoratedViewContainer.propTypes = {
    match: PropTypes.object.isRequired,
    presentation: PropTypes.instanceOf(PresentationRecord),
    meetingLink: PropTypes.string,
    legalConsent: PropTypes.instanceOf(LegalConsentRecord),
    legalConsentFailed: PropTypes.bool.isRequired,
    legalConsentLangLoading: PropTypes.bool.isRequired,
    fetchPresentation: PropTypes.func.isRequired,
    fetchDownloadLink: PropTypes.func,
    fetchLegalConsent: PropTypes.func,
    identifyViewer: PropTypes.func,
    finishActivity: PropTypes.func,
    requiresViewerInfo: PropTypes.any
  };
  return connect(({
    view,
    legalConsent
  }) => ({
    presentation: view.presentation.presentation,
    presentationNotFound: view.presentation.notFound,
    presentationNotAvailableEndDate: view.presentation.notAvailableEndDate,
    noPermission: view.presentation.noPermission,
    meetingLink: view.meetingLink,
    legalConsent: legalConsent.legalConsent,
    legalConsentFailed: legalConsent.legalConsentFailed,
    legalConsentLangLoading: legalConsent.legalConsentLangLoading
  }), {
    fetchPresentation: documentActions.fetchPresentation,
    fetchDownloadLink: documentActions.fetchDownloadLink,
    fetchLegalConsent: documentActions.fetchLegalConsent,
    identifyViewer: publicViewerActions && publicViewerActions.identifyViewer,
    finishActivity: publicViewerActions && publicViewerActions.finishActivity,
    fetchMeetingLink: MeetingsLinkActions.fetchMeetingLinkAction
  })(DecoratedViewContainer);
});